var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6596",
    "data-name": "Path 6596",
    d: "M22.551,20.378V5.172A2.179,2.179,0,0,0,20.378,3H5.172A2.179,2.179,0,0,0,3,5.172V20.378a2.179,2.179,0,0,0,2.172,2.172H20.378A2.179,2.179,0,0,0,22.551,20.378ZM9.408,14.926l2.281,2.748,3.367-4.334a.545.545,0,0,1,.869.011l3.812,5.083a.543.543,0,0,1-.434.869H6.28a.541.541,0,0,1-.424-.88l2.7-3.476A.536.536,0,0,1,9.408,14.926Z",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.ec8e4b7fac28ed9e6b7ed8029742be4d.svg";
export { ForwardRef as ReactComponent };